import React, { useState, useEffect, useCallback } from 'react';
import {IconUploads} from '../../../src/assets/icons/iconUploads';
import { useDropzone } from 'react-dropzone';
import { ContainerDrag } from "../../components/drag-drop-upload/style"


const DragDropUpload = ({ ...props }) => {

  const onDrop = useCallback(acceptedFiles => {
  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <ContainerDrag marginBottom="40px">
      
      <div {...getRootProps()}>
        <input {...getInputProps()} />
            <IconUploads width="auto" height="40px" marginBottom="100px" display="flex" alignItems="center" justifyContent="center"/>
            <label className="legenda" >{props.titulo}</label>
            <label className="legenda" >{props.texto}</label>
        
      </div>

    </ContainerDrag>
  );
};

export default DragDropUpload;